module.exports = __webpack_public_path__ + "static/media/cancel_gray.0322278a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/cancel_gray.svg
// module id = 41
// module chunks = 0